import { Navigate, Route } from 'react-router-dom';

import { PartnerBirthDatePageLazy } from '../pages/ui/partner-birthdate/partner-birthdate.lazy';
import { PartnerBirthPlacePageLazy } from '../pages/ui/partner-birthplace/partner-birthplace.lazy';
import { PartnerBirthTimePageLazy } from '../pages/ui/partner-birthtime/partner-birthtime.lazy';
import { PartnerNamePageLazy } from '../pages/ui/partner-name/partner-name.lazy';
import { PartnerZodiacPageLazy } from '../pages/ui/partner-zodiac/partner-zodiac.lazy';
import { QuestionsPageLazy } from '../pages/ui/questions/questions.lazy';
import { ResultPageLazy } from '../pages/ui/result/result.lazy';
import { YourBirthDatePageLazy } from '../pages/ui/your-birthdate/you-birthdate.lazy';
import { YourBirthPlacePageLazy } from '../pages/ui/your-birthplace/your-birthplace.lazy';
import { YourBirthtimePageLazy } from '../pages/ui/your-birthtime/your-birthtime.lazy';
import { YourGenderPageLazy } from '../pages/ui/your-gender/your-gender.lazy';
import { YourNameLazy } from '../pages/ui/your-name/your-name.lazy';
import { ZodiacPageLazy } from '../pages/ui/zodiac/zodiac.lazy';

export const Q_CompatibilityLongPaths = {
  YourName: () => 'your_name',
  Birthdate: () => 'your_birthdate',
  Birthplace: () => 'your_birthplace',
  Birthtime: () => 'your_birthtime',
  Gender: () => 'gender',
  Zodiac: () => 'your_zodiac',
  PartnerName: () => 'partner_name',
  PartnerBirthdate: () => 'partner_birthdate',
  PartnerBirthPlace: () => 'partner_birthplace',
  PartnerBirthTime: () => 'partner_birthtime',
  PartnerZodiac: () => 'partner_zodiac',
  Questions: () => 'questions',

  Result: () => 'result' as const,
} as const;

const routesConfig = [
  { path: '', element: <Navigate to={Q_CompatibilityLongPaths.YourName()} /> },
  { path: Q_CompatibilityLongPaths.YourName(), element: <YourNameLazy /> },
  { path: Q_CompatibilityLongPaths.Birthdate(), element: <YourBirthDatePageLazy /> },
  { path: Q_CompatibilityLongPaths.Birthplace(), element: <YourBirthPlacePageLazy /> },
  { path: Q_CompatibilityLongPaths.Birthtime(), element: <YourBirthtimePageLazy /> },
  { path: Q_CompatibilityLongPaths.Gender(), element: <YourGenderPageLazy /> },
  { path: Q_CompatibilityLongPaths.Zodiac(), element: <ZodiacPageLazy /> },
  { path: Q_CompatibilityLongPaths.PartnerName(), element: <PartnerNamePageLazy /> },
  { path: Q_CompatibilityLongPaths.PartnerBirthdate(), element: <PartnerBirthDatePageLazy /> },
  { path: Q_CompatibilityLongPaths.PartnerBirthPlace(), element: <PartnerBirthPlacePageLazy /> },
  { path: Q_CompatibilityLongPaths.PartnerBirthTime(), element: <PartnerBirthTimePageLazy /> },
  { path: Q_CompatibilityLongPaths.PartnerZodiac(), element: <PartnerZodiacPageLazy /> },
  { path: Q_CompatibilityLongPaths.Questions(), element: <QuestionsPageLazy /> },

  { path: Q_CompatibilityLongPaths.Result(), element: <ResultPageLazy /> },
];

export const q_CompatibilityLongRoutes = routesConfig.map((route, index) => (
  <Route key={route.path || index} path={route.path} element={route.element} />
));
